<template>
  <el-container class="container" style="padding:0">
    <!-- 侧边栏 -->
    <el-aside width="200px" style="background: white;height:100%">
      <LeftBar :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" @selectChange="leftItemselectChange"/>
    </el-aside>
      <!-- 主要内容容器 - card 类型 -->
      <el-container v-if="currentLeftItem && currentLeftItem.type=='card'" style="position:relative;height:100%">
        <!-- 容器顶部筛选条件按钮 -->
        <el-header style="overflow:unset;height: 60px;background: rgb(245, 247, 250);">
          <CustomTool ref="customToolPerformance" :column_mapper="column_mapper" :default-time="contentMap.asset.defaultTime" :default-date-area="contentMap.performance.defaultDate" :show-time-area="showTimeArea" :show-time="!showTimeArea" :time-area-text="'日期'" :show-see-my-team="true" :show-see-my-dept="true" :show-export="false" :filterArchiveData="filterArchiveData" @filters="filterContentChange" @export="" :todoListInfo="{currentSelectLeftItemKey:currentSelectLeftItemKey,userDeptInfo:userDeptInfo}" :filterOptions="filterOptions" :showPerformanceSelect="true" @setFilterData="setFilterData"/>
        </el-header>
        <div class="performance-card-area" style="height: 100%;padding:20px 40px;overflow: scroll;background:#f5f7fa;">
          <el-row v-for="(rowItem,rowIdx) in contentMap[currentSelectLeftItemKey].contentItems" :gutter="16">
            <el-col v-for="columnItem in rowItem" :span="24/contentMap[currentSelectLeftItemKey].contentItems[rowIdx].length">
              <CustomCard  v-loading="columnItem.loading" :card-data="columnItem" @showDetail="showDetail(columnItem)" @toggleOnlyThisYear="toggleOnlyThisYear(columnItem)" :filterContent="filterContent"/>
            </el-col>
          </el-row>
        </div>

        <CustomDialog v-model="dialogFormVisible" :filterRequestData="filterRequestData" :column_mapper="column_mapper" :indexname="indexname"></CustomDialog>

      </el-container>
      <el-aside v-if="currentLeftItem && currentLeftItem.type=='card' && filterContent.queryCond.length" :width="showFilterBar?'123px':'15px'" style="height:100%;overflow: hidden;z-index: 1;" :style="{background: showFilterBar ? '#F7F9FC':'rgb(245, 247, 250)'}">
        <div style="display: flex;justify-content: start;margin-top: 1px;margin-bottom: 6px;">
          <img v-if="showFilterBar" @click="showFilterBar=false" style="cursor:pointer;" src="../../assets/img/arrow_right.png" width="15" height="15">
          <img v-else @click="showFilterBar=true" style="cursor:pointer;" src="../../assets/img/arrow_left.png" width="15" height="15">
        </div>
        <CustomFilterDrawer v-show="showFilterBar" :column_mapper="column_mapper" :queryCond="filterContent.queryCond" @removeSelect="removeSelect"/>

      </el-aside>
    <!-- iframe 类型 - 展示外部页面 -->
    <div v-if="currentLeftItem && currentLeftItem.type=='iframe'" style="width: calc(100% - 200px); height: 100%; overflow: hidden; display: flex; align-items: center; justify-content: center; background: #f5f7fa;">
      <iframe v-if="currentLeftItem.url" :src="currentLeftItem.url" style="width: 100%; height: 100%; border: none;"></iframe>
      <div v-else style="color: #909399; font-size: 14px;">请配置 ARR 页面的 iframe 地址 (leftItems.[currentLeftItemKey].url)</div>
    </div>
    <div style="width: calc(100% - 200px);" v-if="currentLeftItem && currentLeftItem.type=='table'">
      <CustomTool ref="customToolBaoBiao" :show-custom-btn="true" :custom-btn-text="'查看明细'" @customBtnClick="customBtnClick" :show-filter="false" :show-time-area="false" :default-time="saletable.defaultTime" :show-time="true" :show-export="false" @filters="filterContentChange" @export=""/>
      <MutiTable :card-data="columnItem" :filterRequestData="filterContentBaoBiao"/>
      <SalesDataDetailDialog v-model="salesDataDetailVisble" :filterRequestData="filterContentBaoBiao" :column_mapper="column_mapper"></SalesDataDetailDialog>

    </div>
  </el-container>
</template>

<script>
import CustomTool from "@/component/Performance/topTool/CustomTool";
import CustomCard from "@/component/Performance/CustomCard";
import MutiTable from "@/component/Performance/mutiTable/MutiTable";
import CustomDialog from "@/component/Performance/dialog/CustomDialog";
import SalesDataDetailDialog from "@/component/Performance/dialog/SalesDataDetailDialog";
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import CustomFilterDrawer from "@/component/Bar/customFilterDrawer/CustomFilterDrawer";
import {getPerformance, userDept, getPerformanceOptions} from '../../api/api'
import {getMonthStartDate} from "@/utils/util";
import dayjs from 'dayjs';

export default {
  name: "Performance",
  components:{
    CustomTool,
    CustomCard,
    CustomDialog,
    SalesDataDetailDialog,
    LeftBar,
    CustomFilterDrawer,
    MutiTable
  },
  data(){
    return {
      columnItem:{
        key:"project",
        loading:true,
        height:620,
        title:"订单明细",
        type:"card",
        custom:false,//自定义表头k
        //后台自定义
        showColoums: [
          {
            prop: "project_id",
            label: "订单ID:varchar"
          },
          {
            prop: "project_name",
            label: "订单名称::varchar",
          },
          {
            prop: "quotation_type",
            label: "计价类型:varchar",
          },
          {
            prop: "business_type",
            label: "业务类型:varchar",
          },

          {
            prop: "responsible_p_dept",
            label: "部门:varchar",
          },
          {
            prop: "responsible_s_dept",
            label: "业务组:varchar",
          },
          {
            prop:"ateam",
            label: "销售组:varchar"
          },

          {
            prop:"client_name",
            label: "客户:varchar"
          },
          {
            prop: "account_manager",
            label: "客户经理:varchar",
          },
          {
            prop: "project_manager",
            label: "项目经理:varchar",
          },

          {
            prop: "project_status",
            label: "执行状态:varchar",
          },
          {
            prop: "settlement_status",
            label: "结算状态:varchar",
          },
          {
            prop: "project_stage",
            label: "项目阶段:varchar",
          },

          {
            prop: "amount",
            label: "金额:decimal",
          }
        ],
        tableData:[]
        //     {//自定义表的数据结构
        //   column_comment:{},//名称映射表
        //   data:[],//数据源头
        //   field_list:[]//表头顺序
        // },
      },
      column_mapper:{
        "quotation_type": "计价类型:varchar",
        "business_type": "业务类型:varchar",
        "responsible_p_dept": "部门:varchar",
        "responsible_s_dept": "业务组:varchar",
        "sales_s_dept": "销售组:varchar",
        "client_name": "客户:varchar",
        "account_manager": "客户经理:varchar",
        "project_manager": "项目经理:varchar",
        "first_quotation_time": "首次报价时间:varchar",
        "client_region": "客户地区:varchar",
        "first_business_type": "一级业务类型:varchar"
      },

      leftItems: [
        {
          id: 0,
          name: "销售数据表",
          key: "saletable",
          type:"table",
          hide:true,
          valids:{
            dept:['数据中心']
          }
        },
        {
          id: 1,
          name: "业绩表现",
          key: "performance",
          type:"card",
        },
        // {
        //   id: 2,
        //   name: "产品ARR",
        //   key: "productARR",
        //   type:"iframe",
        //   url: "/productARR/index.html" // 本项目内的静态 ARR 看板页面
        // },
        {
          id: 2,
          name: "企业资产",
          key: "asset",
          type:"card",
        },
        {
          id: 3,
          name: "项目质量",
          key: "projectctl",
          type:"card",
        }
      ],
      currentSelectLeftItemKey:"",
      saletable:{
        defaultTime:new Date().format('yyyy-MM-dd')
      },
      contentMap:{
        performance:{
          timeRangeType:"area",
          defaultDate:{
            defaultStart:getMonthStartDate().format('yyyy-MM-dd'),
            defaultEnd:new Date().format('yyyy-MM-dd')
          },
          salesContentItems:[
            [
              {
                key:"quotation",
                loading:true,
                title:"报价",
                tips:"在所选日期范围内销售报给客户的报价（含税）之和，包括新增和历史调整。",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: "",//同比
                amount_plus_action:"新增",
                amount_minus_action:"调减",
                onlyThisYear:false,
                showOnlyThisYear:true

              },
              {
                key:"income",
                loading:true,
                title:"含税收入",
                tips:"在所选日期范围内业务实施确认的收入（含税）之和，包括新增和历史调整。",
                amount:0,//总额
                amountExcludingTax:-1,
                link_relative_ratio:"",//环比
                year_on_year: "",//同比
                amount_plus_action:"新增",
                amount_minus_action:"调减"
              }
            ],
              [
                {
                  key:"estimated_net_quotation",
                  loading:true,
                  title:"净报价",
                  tips:"报价-预估采购成本",
                  amount:0,//总额
                  amountExcludingTax:0,
                  hideTaxi:true,
                  link_relative_ratio:"",//环比
                  year_on_year: "",//同比
                  amount_type:"doubleAmount",
                  amount_title_1:"报价",
                  amount_plus_action:"新增",
                  amount_minus_action:"调减",
                  amount_plus:0,
                  amount_minus:0,
                  amount_title_2:"预估采购成本",
                  amount_plus_action_2:"新增",
                  amount_minus_action_2:"调减",
                  amount_plus_2:0,
                  amount_minus_2:0,
                  onlyThisYear:false,
                  showOnlyThisYear:true
                },
                {
                  key:"income_no_tax",
                  loading:true,
                  title:"不含税收入",
                  amount:0,//总额
                  amountExcludingTax:-1,
                  hideTaxi:true,
                  link_relative_ratio:"",//环比
                  year_on_year: "",//同比
                  amount_plus_action:"新增",
                  amount_minus_action:"调减"
                }
              ],
            [
              {
                key:"invoice",
                loading:true,
                title:"开票",
                tips:"开票金额之和，包含订单的开票金额和没有关联订单的预付款金额。",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: ""//同比
              },
              {
                key:"purchase_cost",
                loading:true,
                title:"采购成本",
                hideTaxi:true,
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: "",//同比

              }
            ],
              [
                {
                  key:"collection",
                  loading:true,
                  title:"收款",
                  tips:"收款金额之和，包含已开票的收款和未开票的收款",
                  amount:0,//总额
                  amountExcludingTax:0,
                  link_relative_ratio:"",//环比
                  year_on_year: ""//同比
                },
                {
                  key:"gross_profit",
                  loading:true,
                  hideTaxi:true,
                  title:"业务毛利",
                  tips:"即不计算人工成本的业务毛利，业务毛利=不含税收入-采购成本",
                  amount:0,//总额
                  amountExcludingTax:0,
                  link_relative_ratio:"",//环比
                  year_on_year: "",//同比
                  amount_type:"doubleAmount",
                  amount_title_1:"不含税收入",
                  amount_plus_action:"新增",
                  amount_minus_action:"调减",
                  amount_plus:0,
                  amount_minus:0,
                  amount_title_2:"采购成本",
                  amount_plus_action_2:"新增",
                  amount_minus_action_2:"调减",
                  amount_plus_2:0,
                  amount_minus_2:0,
                }
              ]
            // [
            //   {
            //     key:"cost",
            //     loading:true,
            //     title:"成本",
            //     description:"(不含人工成本)",
            //     amount:0,//总额
            //     amountExcludingTax:0,
            //     link_relative_ratio:"",//环比
            //     year_on_year: ""//同比
            //   },
            //   {
            //     key:"profit",
            //     loading:true,
            //     title:"利润",
            //     description:"(不含人工成本)",
            //     amount:0,//总额
            //     amountExcludingTax:0,
            //     link_relative_ratio:"",//环比
            //     year_on_year: ""//同比
            //   }
            // ]
          ],
          nonSalesContentItems:[
            [
              {
                  key:"gross_profit",
                  loading:true,
                  hideTaxi:true,
                  title:"业务毛利",
                  tips:"即不计算人工成本的业务毛利，业务毛利=不含税收入-采购成本",
                  amount:0,//总额
                  amountExcludingTax:0,
                  link_relative_ratio:"",//环比
                  year_on_year: "",//同比
                  amount_type:"doubleAmount",
                  amount_title_1:"不含税收入",
                  amount_plus_action:"新增",
                  amount_minus_action:"调减",
                  amount_plus:0,
                  amount_minus:0,
                  amount_title_2:"采购成本",
                  amount_plus_action_2:"新增",
                  amount_minus_action_2:"调减",
                  amount_plus_2:0,
                  amount_minus_2:0,
              },
              {
                key:"quotation",
                loading:true,
                title:"报价",
                tips:"在所选日期范围内销售报给客户的报价（含税）之和，包括新增和历史调整。",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: "",//同比
                amount_plus_action:"新增",
                amount_minus_action:"调减",
                onlyThisYear:false,
                showOnlyThisYear:true
              }
            ],
              [
                {
                  key:"income_no_tax",
                  loading:true,
                  title:"不含税收入",
                  amount:0,//总额
                  amountExcludingTax:-1,
                  hideTaxi:true,
                  link_relative_ratio:"",//环比
                  year_on_year: "",//同比
                  amount_plus_action:"新增",
                  amount_minus_action:"调减"
                },
                {
                  key:"estimated_net_quotation",
                  loading:true,
                  title:"净报价",
                  tips:"报价-预估采购成本",
                  amount:0,//总额
                  amountExcludingTax:0,
                  hideTaxi:true,
                  link_relative_ratio:"",//环比
                  year_on_year: "",//同比
                  amount_type:"doubleAmount",
                  amount_title_1:"报价",
                  amount_plus_action:"新增",
                  amount_minus_action:"调减",
                  amount_plus:0,
                  amount_minus:0,
                  amount_title_2:"预估采购成本",
                  amount_plus_action_2:"新增",
                  amount_minus_action_2:"调减",
                  amount_plus_2:0,
                  amount_minus_2:0,
                  onlyThisYear:false,
                  showOnlyThisYear:true
                }
              ],
            [
              {
                key:"purchase_cost",
                loading:true,
                title:"采购成本",
                hideTaxi:true,
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: "",//同比
              },
              {
                key:"invoice",
                loading:true,
                title:"开票",
                tips:"开票金额之和，包含订单的开票金额和没有关联订单的预付款金额。",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: ""//同比
              }
            ],
              [
                {
                  key:"income",
                  loading:true,
                  title:"含税收入",
                  tips:"在所选日期范围内业务实施确认的收入（含税）之和，包括新增和历史调整。",
                  amount:0,//总额
                  amountExcludingTax:-1,
                  link_relative_ratio:"",//环比
                  year_on_year: "",//同比
                  amount_plus_action:"新增",
                  amount_minus_action:"调减"
                },
                {
                  key:"collection",
                  loading:true,
                  title:"收款",
                  tips:"收款金额之和，包含已开票的收款和未开票的收款",
                  amount:0,//总额
                  amountExcludingTax:0,
                  link_relative_ratio:"",//环比
                  year_on_year: ""//同比
                }
              ]
          ],
          // contentItems: this.contentMap.performance.salesContentItems
          contentItems: [[],[],[],[]]
        },
        asset:{
          timeRangeType:"single",
          defaultTime:new Date().format('yyyy-MM-dd'),
          contentItems:[
            [
              {
                key:"unfinished_quotation",
                loading:true,
                title:"在手订单",
                tips:"1）已验收、暂停、废止的订单在手订单为0；\n" +
                    "2）创金合信基金的代运营业务在手订单为0；\n" +
                    "3）若报价小于收入则在手订单为0；\n" +
                    "4）不属于上述3种情况的订单在手订单=订单报价-订单收入",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: ""//同比
              },
              {
                key:"unfinished_inventory",
                loading:true,
                title:"变现存量",
                tips:"1）若收入小于开票则变现存量为0；\n" +
                    "2）不属于上述情况的订单变现存量=订单收入-订单开票",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: ""//同比
              }
            ],
              [
                {
                  key:"finished_not_invoice",
                  loading:true,
                  title:"已验收\n未开票",
                  tips:"属于变现存量的子集，主要针对的是已验收的项目。当执行状态=已验收时，已验收未开票=收入-开票",
                  amount:0,//总额
                  amountExcludingTax:0,
                  link_relative_ratio:"",//环比
                  year_on_year: ""//同比
                },
                {
                  key:"invoice_not_collection",
                  loading:true,
                  title:"应收账款",
                  tips:"即已开票未收款，已开票未收款=开票-收款",
                  amount:0,//总额
                  amountExcludingTax:0,
                  link_relative_ratio:"",//环比
                  year_on_year: ""//同比
                }
              ]
          ]
        },
        projectctl:{
          timeRangeType:"single",
          contentItems:[
            [
              {
                key:"unfinished_quotation",
                loading:true,
                title:"报价收入\n差额",
                tips:"报价收入差额=订单报价-订单收入。其中正数为订单报价大于订单收入部分，负数为订单报价小于订单收入部分。一般来说，报价一定会大于收入，如若有负数，那么说明有订单是异常并需要调整数据的。",

                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: ""//同比
              },
              {
                key:"unfinished_inventory",
                loading:true,
                title:"收入开票\n差额",
                tips:"收入开票差额=订单收入-订单开票。其中正数表示订单已填进度但还未开票的金额，负数表示订单已开票还需要填写收入的部分。",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: ""//同比
              }
            ],
            [
              {
                key:"unfinished_collection",
                loading:true,
                title:"开票收款\n差额",
                tips:"开票收款差额=订单开票-订单收款。开票一定会大于收款，如若有负数，那么说明有系统数据有问题。",
                amount:0,//总额
                amountExcludingTax:0,
                link_relative_ratio:"",//环比
                year_on_year: ""//同比
              },
              {
                key:"placeholder",
                loading:false
              }
            ]
          ]
        }
      },

      dialogFormVisible:false,
      salesDataDetailVisble:false,
      filterRequestData:{},
      filterContent:{
        queryCond: [],
        timerange:{
          start:getMonthStartDate().format('yyyy-MM-dd'),
          end:(new Date()).format('yyyy-MM-dd')
        },
        time:(new Date()).format('yyyy-MM-dd')
      },
      filterContentBaoBiao:{
        time:(new Date()).format('yyyy-MM-dd')
      },
      filterArchiveData:{
        start_end_date_dynamic:[],
        queryCond: []
      },
      showFilterBar:true,

      showTimeArea:true,
      userDeptInfo:{},

      indexname: "",

      // 下拉筛选项
      filterOptions: {
        client_region: {
          name: '客户地区',
          options: [],
          value: ''
        },
        responsible_s_dept: {
          name: '业务组',
          options: [],
          value: ''
        },
        responsible_p_dept: {
          name: '部门',
          options: [],
          value: ''
        },
        first_business_type: {
          name: '一级业务类型',
          options: [],
          value: ''
        }
      }
    }
  },
  computed: {
    currentLeftItem() {
      return this.leftItems.find(item => item.key === this.currentSelectLeftItemKey) || null
    }
  },
  created () {
    // 客户地区选项
    getPerformanceOptions({
      index: "client_region"
    }).then(result => {
      this.filterOptions.client_region = { name: '客户地区', options: result.respData }
    })
    // 业务组选项
    getPerformanceOptions({
      index: "responsible_s_dept"
    }).then(result => {
      this.filterOptions.responsible_s_dept = { name: '业务组', options: result.respData }
    })
    // 部门选项
    getPerformanceOptions({
      index: "responsible_p_dept"
    }).then(result => {
      this.filterOptions.responsible_p_dept = { name: '部门', options: result.respData }
    })
    // 一级业务类型
    getPerformanceOptions({
      index: "first_business_type"
    }).then(result => {
      this.filterOptions.first_business_type = { name: '一级业务类型', options: result.respData }
    })
  },
  async mounted() {
    window.vm4 = this
    await this.getUserDept()
      for (const leftItem of this.leftItems) {
        // console.log('leftItemleftItem',leftItem)
        if(leftItem.hasOwnProperty('valids')){

          if(leftItem.valids.hasOwnProperty('dept')){
            let validDepts = leftItem.valids.dept
            // console.log('validDepts',validDepts)
            if(validDepts.indexOf(this.userDeptInfo.p_dept_name)!==-1){
              // console.log('找到了',this.userDeptInfo.p_dept_name)
              leftItem.hide = false
            }else{
              leftItem.hide = true
            }
          }
        }
      }

    let firstShowItem = this.leftItems.find(leftItem=>!leftItem.hide)
    if(firstShowItem){
      this.currentSelectLeftItemKey=firstShowItem.key
    }

    this.contentMap.performance.contentItems = this.userDeptInfo.p_dept_name==="营销部门"?this.contentMap.performance.salesContentItems:this.contentMap.performance.nonSalesContentItems

    this.getPerformanceData()
    // this.getUserDept()
  },
  methods:{
    setFilterData({ key, value }) {
      for (const name in this.filterOptions) {
        this.filterOptions[name].value = ''
      }
      key && (this.filterOptions[key].value = value)
    },
    removeSelect(item){
      this.$refs.customToolPerformance.removeSelect(item)
    },
    async getUserDept(){
      let res = await userDept({})
      // console.log('getUserDept',res)
      if(res.respCode=="000000"){
        this.userDeptInfo = res.respData
      }else{
        this.$message.warning(res.respMsg)
      }
    },
    leftItemselectChange(key){
      console.log('左侧item切换',key)
      this.currentSelectLeftItemKey = key
      let itemInfo = this.leftItems.find(item=>item.key==key)
      if(itemInfo.type=='card'){
        if(key=='performance'){
          this.showTimeArea = true
        }else{
          this.showTimeArea = false
        }
        this.refresh()
      }else if(itemInfo.type=='table'){
        console.log('table类型')
      }
      // iframe 类型无需额外逻辑，仅切换展示
    },

    toggleOnlyThisYear(cardData){
      cardData.onlyThisYear = !cardData.onlyThisYear
      this.getPerformanceDataByContent(cardData)
    },

    async getPerformanceDataByContent(content){

          let postData = {
            index: content.key,
            division: this.currentSelectLeftItemKey,
            dimension:"",
            ...this.filterContent
          }
          postData = JSON.parse(JSON.stringify(postData))
          if(content.onlyThisYear==true){
            postData.queryCond.push({
              columnName:"first_quotation_time",
              columnValue:dayjs().startOf('year').format('YYYY-MM-DD'),
              filter: "ge"
            })
          }
          if(this.contentMap[this.currentSelectLeftItemKey].timeRangeType=='single'){
            postData.timerange = {start: "2018-01-01", end: this.filterContent.time}
          }
          console.log('过滤条件2/postData',postData)
          getPerformance(postData).then(res=>{
            let resData = res.data.respData
            console.log('过滤条件返回结果/filterContent',resData,content.key)
            // content.amount = resData instanceof Array && resData.length && resData[0].amount ? resData[0].amount : 0
            // content.link_relative_ratio = resData[0].link_relative_ratio
            // content.year_on_year = resData[0].year_on_year
            if(res.data.respCode=="000000"){
              Object.assign(content,resData[0])
            }else{
              console.error("getPerformance失败了",res.data.respMsg)
            }

            console.log('content',content,'content.amount',content.amount)
            this.$nextTick(()=>{
              content.loading = false
            })
          })




    },

    showDetail(cardData){
      console.log('showDetail',cardData)
      let postDat = {
        index:cardData.key,
        title:cardData.title,
        division: this.currentSelectLeftItemKey,
        ...this.filterContent
      }
      postDat = JSON.parse(JSON.stringify(postDat))
      console.log('postDat1',postDat,JSON.stringify(this.filterContent))
      if(this.contentMap[this.currentSelectLeftItemKey].timeRangeType=='single'){
        postDat.timerange = {start: "2018-01-01", end: this.filterContent.time}
      }
      if(cardData.onlyThisYear==true){
        postDat.queryCond.push({
          columnName:"first_quotation_time",
          columnValue:dayjs().startOf('year').format('YYYY-MM-DD'),
          filter: "ge"
        })
      }

      this.filterRequestData = postDat
      // this.filterRequestData = {
      //   index:cardData.key,
      //   title:cardData.title,
      //   division: this.currentSelectLeftItemKey,
      //   ...this.filterContent
      // }
      this.dialogFormVisible = !this.dialogFormVisible
      this.indexname = cardData.key
    },

    customBtnClick(){
      console.log('销售数据表查看明细')
      this.salesDataDetailVisble = !this.salesDataDetailVisble
    },
    filterContentChange(content){
      console.log('filterContentChange',content)
      let itemInfo = this.leftItems.find(item=>item.key==this.currentSelectLeftItemKey)
      if(itemInfo.type=='card'){
        this.filterContent = Object.assign(this.filterContent,content)

        if(this.filterContent.timerange){
          this.contentMap.performance.defaultDate.defaultStart = this.filterContent.timerange.start
          this.contentMap.performance.defaultDate.defaultEnd = this.filterContent.timerange.end
        }
        if(this.filterContent.time){
          this.contentMap.asset.defaultTime = this.filterContent.time
        }

        this.getPerformanceData()
      }else if(itemInfo.type=='table'){
        this.filterContentBaoBiao = content
        if(this.filterContentBaoBiao.time){
          this.saletable.defaultTime = this.filterContentBaoBiao.time
        }
        console.log('this.filterContentBaoBiao',this.filterContentBaoBiao)
      }


    },

    async getPerformanceData(){
      if(this.currentSelectLeftItemKey=='saletable')return
      let contents = this.contentMap[this.currentSelectLeftItemKey].contentItems.reduce((a,b)=>[...a,...b],[])
      console.log('平铺contents',contents)
      for (const content of contents) {
        if(content.key=='placeholder')continue
        content.loading = true
      }
      this.$nextTick(()=>{
        for (const content of contents) {
          if(content.key=='placeholder')continue
          let postData = {
            index: content.key,
            division: this.currentSelectLeftItemKey,
            dimension:"",
            ...this.filterContent
          }
          postData = JSON.parse(JSON.stringify(postData))
          if(content.onlyThisYear==true){
            postData.queryCond.push({
              columnName:"first_quotation_time",
              columnValue:dayjs().startOf('year').format('YYYY-MM-DD'),
              filter: "ge"
            })
          }
          if(this.contentMap[this.currentSelectLeftItemKey].timeRangeType=='single'){
            postData.timerange = {start: "2018-01-01", end: this.filterContent.time}
          }
          console.log('过滤条件/postData',postData)
          getPerformance(postData).then(res=>{
            let resData = res.data.respData
            console.log('CustomCardTable过滤条件/postData2',resData,content.key)
            // content.amount = resData instanceof Array && resData.length && resData[0].amount ? resData[0].amount : 0
            // content.link_relative_ratio = resData[0].link_relative_ratio
            // content.year_on_year = resData[0].year_on_year
            if(res.data.respCode=="000000"){
              Object.assign(content,resData[0])
            }else{
              console.error("getPerformance失败了",res.data.respMsg)
            }

            console.log('content',content,'content.amount',content.amount)
            this.$nextTick(()=>{
              content.loading = false
            })
          })

        }
      })

    },

    refresh(){
      this.getPerformanceData()
    }
  }
}
</script>
<style lang="scss">
/* 卡片区域：收紧卡片之间的行列间距 */
.performance-card-area {
  .el-row {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

